import "../../index42.css";
import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { a as r } from "../../core-DVmjA3_O.js";
import { _ as g } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import v from "../Spinner/index.js";
const z = "_message_1upz9_1", x = "_icon_1upz9_13", D = "_spinner_1upz9_19", j = "_title_1upz9_25", w = "_errored_1upz9_31", T = "_compact_1upz9_37", e = {
  message: z,
  icon: x,
  spinner: D,
  title: j,
  errored: w,
  compact: T
};
function A(l) {
  const {
    className: d,
    pending: i = !1,
    variant: _,
    icon: c,
    title: t,
    description: n,
    actions: a,
    compact: f = !1,
    errored: o,
    erroredTitle: p,
    erroredDescription: u
  } = l, h = o ? r(p) : r(t), N = o ? r(u) : r(n);
  return /* @__PURE__ */ m(
    "div",
    {
      className: g(
        e.message,
        _ === "error" && e.errored,
        f && e.compact,
        d
      ),
      children: [
        (c || i) && /* @__PURE__ */ m("div", { className: e.icon, children: [
          i && /* @__PURE__ */ s(v, { className: e.spinner }),
          !i && c
        ] }),
        h && /* @__PURE__ */ s("div", { className: e.title, children: o ? p : t }),
        N && /* @__PURE__ */ s("div", { className: e.description, children: n }),
        a && /* @__PURE__ */ s("div", { className: e.actions, children: a })
      ]
    }
  );
}
export {
  A as default
};
